import { useRouter } from "vue-router";


export function productUse() {

    const router = useRouter();


    async function goToPublicityGallery() {
        await router.push("/publicity-gallery");
        window.scrollTo(0, 0);
    }

    async function goToEcommerceGallery() {
        await router.push("/ecommerce-gallery");
        window.scrollTo(0, 0);
    }


    return {
        goToPublicityGallery,
        goToEcommerceGallery,
    };
}
